export default () => '/tolls';
